import { useEffect } from 'react';
import { autoComplete, fetchFiltersAndTemplates, loadMoreTemplates, refreshTemplates, toggleFavorite, } from '../state/TemplateEffects';
import useTemplateReducer from '../state/TemplateReducer';
import { clearFilters, handleFilterUpdate } from '../../../utils/filters';
export const useTemplates = (defaultQueryFilters, enableUrlPersist) => {
    const [state, dispatch] = useTemplateReducer();
    useEffect(() => {
        init();
    }, [defaultQueryFilters]);
    const init = () => {
        fetchFiltersAndTemplates(dispatch, false, state, false, defaultQueryFilters, enableUrlPersist, defaultQueryFilters?.offset);
    };
    const onFilterCollapsed = (filter, collapsed) => {
        dispatch({ type: 'filter-collapsed', filter, collapsed });
    };
    const onFilterSelected = (filter, selected, filterParentKey) => {
        const { filters, searchQuery } = state;
        const updatedFilters = handleFilterUpdate(filters, { selected }, filter);
        dispatch({ type: 'filters-updated', filters: updatedFilters });
        refreshTemplates(dispatch, 0, updatedFilters, searchQuery, false, state, '16:9', filterParentKey, false);
    };
    const onClearAll = () => {
        const { filters, searchQuery } = state;
        const unselectedFilters = clearFilters(filters);
        dispatch({ type: 'filters-cleared' });
        refreshTemplates(dispatch, 0, unselectedFilters, searchQuery, false, state);
    };
    const fetchMoreTemplates = () => {
        if (state.loading.templates) {
            return;
        }
        loadMoreTemplates(dispatch, state.templates.offset, state.filters, state.searchQuery, false, state);
    };
    const searchTemplates = (searchQuery) => {
        dispatch({ type: 'search-query-updated', searchQuery });
        refreshTemplates(dispatch, 0, state.filters, searchQuery, false, state);
    };
    const autoCompleteSearch = async (searchQuery) => {
        const suggestions = await autoComplete(searchQuery);
        return suggestions;
    };
    const onFavouriteClick = (template, isFavouriteTemplate, workflow) => {
        toggleFavorite(dispatch, {
            template_id: template.id,
            dimensions: template.dimensions,
            status: !isFavouriteTemplate,
            workflow: workflow,
        });
    };
    return {
        state,
        dispatch,
        onFilterSelected,
        onFilterCollapsed,
        onClearAll,
        fetchMoreTemplates,
        searchTemplates,
        autoCompleteSearch,
        onFavouriteClick,
    };
};
